import $ from 'jquery';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import frm from './formAux.js';
// import Plot from 'react-plotly.js';
import c3 from 'c3';
import * as d3 from "d3";
import 'c3/c3.css';
// import './c3.css';


var charMinHeight = 420,
	charPlusHeight = 70,
	colorPattern = [
		//"#3f407a", "#6f6fd3", /*"#f7f1e3",*/ "#34ace0", "#50d9b2",
		//"#f0c539", "#e67f34", "#e74c3c", /*"#ecf0f1",*/ /*"#94a5a6",*/
		//"#44bd9c", "#58cc72", "#3398db",
		"#34495e", "#9b5cb6",
		"#f85151", "#fb783e", /*"#d1ccc0",*/ "#ffb142", "#ffda79",
		"#38a185", "#4aaf60", "#2a80b9", "#9057ad", "#2c3e50",
		"#f29d38", "#d2562e", "#c0392b", /*"#bdc3c7", "#7f8c8d",*/
		"#2c2c54", "#474787", /*"#aaa69d",*/ "#217093", "#308c74",
		"#b33939", "#cd6133", /*"#84817a",*/ "#cc8e35", "#ccae62",
	],
	dataColorPattern = {
		SSD:"#FF0000",STILL:"#FFAB07",
		PADARIA:"#F3D100", BAR:"#5FBF64", MERCEARIA:"#FFAB07", "AS 5 + CK":"#0E8D94", "AS 1-4 CK":"#3E5E72","AS 5-19 CK":"#f44336","AS 20+ CK":"#2196f3", "OUTROS":"#444444",
		MINIMERCADO:"#3E5E72", SUPER:"#0E8D94", ATACADO:"#BA68C6", HIPER:"#3f51b5",
		EXCLUIDO:"#444444",LANCHONETE:"#e64a19",RESTAURANTE:"#00bcd4","CASH & CARRY":"#BA68C6",
		MINI:"#3E5E72",BOTECO:"#5FBF64",
        "HIPERMERCADO (AS 20+CK)":"#2196f3","CONVENIÊNCIA":"#7f7f7f",
        "MINIMERCADO (AS 1-4CK)":"#3E5E72","SUPERMERCADO (AS 5-19CK)":"#f44336",
	};

function otxt( s ){ return s }
function val( n, dec ) { return n }
function getSaveName(){ return 'file'}

var _runningCount = [];
function isRunning(){ return _runningCount.length ? true : false; }
function pushRunning(c){ _runningCount.push(1); if( c ){ for(var i=1;i<c;i++) pushRunning(); } }
function popRunning(){ _runningCount.pop();
	if( !_runningCount.length && window['onFinishRunning'] instanceof Function ) window.onFinishRunning();
}
function clearRunning(){ _runningCount=[]; };

function isNumber(n){ return Number(n) == n && !isNaN(n); }
function isInt(n){ return isNumber(n) && Number(n)%1 === 0; }
function isFloat(n){ return isNumber(n) && Number(n) % 1 !== 0; }


function drawGraphLine(data,cfg){

	var graph,
		title,
		isUpdate=false;

	if( (title=cfg.container.find("h4.chart-title")).length != 1 || (graph=cfg.container.find("div[data-chart]")).length != 1 )
	{
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>"+otxt(cfg.title)+"</h4>").append( graph );
	}
	else
	{
		title.html( otxt(cfg.title) );
		isUpdate=true;
	}

	var columns = [],
		odados = [];
	var total;

	//console.log(data);
	if( !data.empty )
	{
		odados = data.values.slice();
		total = getTotal( odados );

		$( data.yLabels ).each(function(i,name){
			var dados = [];

			$( odados ).each(function(j,v) {
				var dado=null;
				if( !cfg.basevalue ) dado = v[i];
				else if( (cfg.basevalue) instanceof Function )
				{
					dado = cfg.basevalue.call(this,v[i],total);
					//console.log( j, v[i] , dado );
				}
				else
				{
					dado = v[i][cfg.basevalue];
				}
				dados.push(dado);
			});

			dados.unshift( name.toString() );
			columns.push( dados );
		});
	}


	var g_cfg = {
			bindto:graph.get(0),
			color:{
				pattern:colorPattern,
			},
			size:{
				height:charMinHeight,
			},
			data: {
				columns: columns,
				colors:dataColorPattern,
			},
			axis:{
				x:{
					type: 'category',
					categories:data.xLabels,
				},
				y:{
                    show:true,
                }
			},
			tooltip:{
				contents:function(d, defaultTitleFormat, defaultValueFormat, color){
					if( Function.apply ) return chartTooltipContents.apply(this,arguments);
					return chartTooltipContents.call(this,d, defaultTitleFormat, defaultValueFormat, color);
				},
				format:{
					value:function(value,ratio,id,index){
						return val(value);//+" UNIT";
					}
				}
			}
		};


    if( cfg.showPositionInTooltip )
        g_cfg.showPositionInTooltip = cfg.showPositionInTooltip;

	if( cfg.colorPattern )
		g_cfg.color.pattern = cfg.colorPattern;
	if( cfg.dataColors )
		g_cfg.data.colors = cfg.dataColors;
	if( cfg.hideLegends )
		g_cfg.legend = { show: false };

    if( cfg.hideY ){
        g_cfg.axis.y.show = !cfg.hideY;
    }


	if( cfg.padding ){
		g_cfg.padding = cfg.padding;
	}

	if( cfg.size ){
		g_cfg.size = cfg.size;
	}

	if ( g_cfg.data.columns.length > 10 ){
		g_cfg.size.height += charPlusHeight * ( (g_cfg.data.columns.length / 10) * 0.8 );

		console.log( g_cfg.size.height );
	}

	if( isUpdate ){
        var last_g_cfg = graph.prop("g_cfg");
        if( last_g_cfg.data.type != g_cfg.data.type ){
            isUpdate = false;
            graph.html("");
        }
    }

	var chart;
	if( isUpdate )
	{
		var unload=[];
		chart = graph.prop("chart");
		var last_g_cfg = graph.prop("g_cfg"),
			conf;


		if( !data.empty )
		{
			if( g_cfg.data.columns instanceof Array ){
				for( var i in last_g_cfg.data.columns )
					unload.push( last_g_cfg.data.columns[i][0] );
				for( var i in g_cfg.data.columns )
					if( unload.indexOf( g_cfg.data.columns[i][0] ) != -1 ){
						unload.splice( unload.indexOf( g_cfg.data.columns[i][0] ) , 1 );
					}
			}

			conf = {unload:unload, columns:g_cfg.data.columns, rows:g_cfg.data.rows,categories:g_cfg.axis.x.categories, type:g_cfg.data.type };
		}
		else
		{
			conf = {unload:true};
		}

		chart.load( conf );
		if( last_g_cfg.size.height != g_cfg.size.height )
			setTimeout(function(){
				chart.resize({height:g_cfg.size.height});
			},660);

		if( !last_g_cfg.legendIsHide && g_cfg.data.columns.length >= 20 )
		{
			g_cfg.legendIsHide = true;
			setTimeout(function(){
				chart.legend.hide();
			},150);
		}
		else if( last_g_cfg.legendIsHide && g_cfg.data.columns.length < 20 )
		{
			delete g_cfg.legendIsHide;
			setTimeout(function(){
				chart.legend.show();
			},150);
		}

	}
	else
	{
		chart=c3.generate( g_cfg );
	}

	graph.attr({'data-chart':1}).prop({'chart':chart,'g_cfg':g_cfg});

}

function drawGraphBar(data,cfg){

	let myCfg = {};
	for( let i in cfg ) {
		myCfg[i] = cfg[i];
		if( typeof(myCfg[i]) == 'function' ) myCfg[i] = myCfg[i].toString().replace(/\n/g, ' ').replace(/[ \t]+/g,' ');
	}
	myCfg = JSON.stringify(myCfg,null,'\t');
	myCfg = myCfg.replace(/"(function .*})"/g, "$1")
	console.log( 'CHARTDATA BAR', 'let data =', JSON.stringify(data, null, '\t')+';\nlet cfg = ' + myCfg + ';\n' )
	var graph,
		title,
		isUpdate=false;

	if( (title=cfg.container.find("h4.chart-title")).length != 1 || (graph=cfg.container.find("div[data-chart]")).length != 1 )
	{
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>"+otxt(cfg.title)+"</h4>").append( graph );
	}
	else
	{
		title.html( otxt(cfg.title) );
		isUpdate=true;
	}

	var columns = [],
		odados = [],
		total;

	if( !data.empty )
	{
		odados = data.values.slice();
		total = getTotal( odados );

		$( data.yLabels ).each(function(i,name){
			var dados = [];
			$( odados ).each(function(j,v){
				var dado=null;
				if( !cfg.basevalue ) dado = v[i];
				else if( (cfg.basevalue) instanceof Function )
				{
					dado = cfg.basevalue.call(this,v[i],total[j]);
				}
				else
				{
					dado = (v[i][cfg.basevalue]/total[j][cfg.basevalue])*100;
				}
				dados.push( dado );
			});


			dados.unshift( name.toString() );
			columns.push( dados );
		});
	}
	// console.log( 'XXXXXXXXXXXXXXX',columns )

	var g_cfg = {
			bindto:graph.get(0),
			color:{
				pattern:colorPattern,
			},
			size:{
				height:charMinHeight,
			},
			data: {
				type:'bar',
				columns: columns,
				colors:dataColorPattern,
				// color: function (color, d) { return ['#0000ff','#ff0000'][d.x]; },
				labels:{
					format: function (v, id, i, j) { return val(v); },
				},
			},
			axis:{
				x:{
					type: 'category',
					categories:data.xLabels,
					fit: true,
				},
				y:{
					max:cfg.max||void 0,
					min:cfg.min||void 0,
					padding:0,
					tick:{
						format:function(d){ return d },
					},
                    show:true,
					fit: true,
				}
			},
			tooltip:{
				contents:function(d, defaultTitleFormat, defaultValueFormat, color){
					// console.log( 'tooltip', d, color )
					if( Function.apply ) return chartTooltipContents.apply(this,arguments);
					return chartTooltipContents.call(this,d, defaultTitleFormat, defaultValueFormat, color);
				},
				format:{
					value:function(value,ratio,id,index){
						return val(value)+" %";
					}
				}
			}
		};

	if( cfg.ratiobar ){
		if( !('bar' in g_cfg) ) g_cfg['bar'] = {};
		g_cfg.bar.width = {
			ratio:cfg.ratiobar
		};
	}
	if( cfg.widthbar ){
		if( !('bar' in g_cfg) ) g_cfg['bar'] = {};
		g_cfg.bar.width = cfg.widthbar;
	}
	if( cfg.format )
	{
		g_cfg.data.labels.format = cfg.format;
	}
	if( cfg.formatTooltip )
	{
		g_cfg.tooltip.format.value = cfg.formatTooltip;
	}
	if( cfg.formatTick )
	{
		g_cfg.axis.y.tick.format = cfg.formatTick;
	}
    if( cfg.showPositionInTooltip )
        g_cfg.showPositionInTooltip = cfg.showPositionInTooltip;

	if( cfg.groups && !data.empty )
	{
		g_cfg.data.groups= [ data.yLabels ];
		delete g_cfg.data.labels;
	}


	if( cfg.padding ){
		g_cfg.padding = cfg.padding;
	}

	if( cfg.size ){
		g_cfg.size = cfg.size;
	}


	if ( g_cfg.data.columns.length > 10 ){
		g_cfg.size.height += charPlusHeight * ( (g_cfg.data.columns.length / 10) * 0.5 );
	}

	if( cfg.colorPattern )
		g_cfg.color.pattern = cfg.colorPattern;
	if( cfg.dataColors )
		g_cfg.data.colors = cfg.dataColors;
	if( cfg.dataColor )
		g_cfg.data.color = cfg.dataColor;
	if( cfg.hideLegends )
		g_cfg.legend = { show: false };
    if( cfg.paddingY ){
        g_cfg.axis.y.padding = cfg.paddingY;// {top:,left:...}
    }
	if( cfg.rotated ) g_cfg.axis.rotated = cfg.rotated;
	// if( cfg.xHeight ) g_cfg.axis.x.height = cfg.xHeight;

	// console.log( 'cfg', g_cfg )

    if( cfg.hideY ){
        g_cfg.axis.y.show = !cfg.hideY;
    }

    if( isUpdate ){
        var last_g_cfg = graph.prop("g_cfg");
        if( last_g_cfg.data.type != g_cfg.data.type ){
            isUpdate = false;
            graph.html("");
        }
    }


	var chart;
	if( isUpdate )
	{
		var unload=[];
		chart = graph.prop("chart");
		var last_g_cfg = graph.prop("g_cfg"),
			conf;

		if( !data.empty )
		{
			if( g_cfg.data.columns instanceof Array ){
				for( var i in last_g_cfg.data.columns )
					unload.push( last_g_cfg.data.columns[i][0] );
				for( var i in g_cfg.data.columns )
					if( unload.indexOf( g_cfg.data.columns[i][0] ) != -1 ){
						unload.splice( unload.indexOf( g_cfg.data.columns[i][0] ) , 1 );
					}
			}

			conf = {unload:unload, columns:g_cfg.data.columns, rows:g_cfg.data.rows, categories:g_cfg.axis.x.categories, type:g_cfg.data.type };
		}
		else
		{
			conf = {unload:true};
		}

		chart.load( conf );
		if( cfg.groups )
		{
			chart.groups( g_cfg.data.groups );
		}


		if( last_g_cfg.size.height != g_cfg.size.height )
			setTimeout(function(){
				chart.resize({height:g_cfg.size.height});
			},660);

		if( !last_g_cfg.legendIsHide && g_cfg.data.columns.length >= 20 )
		{
			g_cfg.legendIsHide = true;
			setTimeout(function(){
				chart.legend.hide();
			},150);
		}
		else if( last_g_cfg.legendIsHide && g_cfg.data.columns.length < 20 )
		{
			delete g_cfg.legendIsHide;
			setTimeout(function(){
				chart.legend.show();
			},150);
		}

	}
	else
	{
		chart=c3.generate( g_cfg );
	}

	// console.log( 'CHART',chart, 'GCFG', g_cfg );
	graph.attr({'data-chart':1}).prop({'chart':chart,'g_cfg':g_cfg});

}


function drawGraphDonut(data,cfg){
	let myCfg = {};
	for( let i in cfg ) {
		myCfg[i] = cfg[i];
		if( typeof(myCfg[i]) == 'function' ) myCfg[i] = myCfg[i].toString().replace(/\n/g, ' ').replace(/[ \t]+/g,' ');
	}
	myCfg = JSON.stringify(myCfg,null,'\t');
	myCfg = myCfg.replace(/"(function .*})"/g, "$1")
	console.log( 'CHARTDATA DONUT', 'let data =', JSON.stringify(data, null, '\t')+';\nlet cfg = ' + myCfg + ';\n' )

	var graph,
		title,
		isUpdate=false;

	if( (title=cfg.container.find("h4.chart-title")).length != 1 || (graph=cfg.container.find("div[data-chart]")).length != 1 )
	{
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>"+otxt(cfg.title)+"</h4>").append( graph );
	}
	else
	{
		title.html( otxt(cfg.title) );
		isUpdate=true;
	}




	var columns = [],
		odados = [];

	//console.log(data);
	if( !data.empty )
	{
		odados = data.values.slice();
		var total = getTotal( odados );

		$( data.yLabels ).each(function(i,name){
			var dados = [];

			$( odados ).each(function(j,v){
				var dado=null;
				if( !cfg.basevalue ) dado = v[i];
				else if( (cfg.basevalue) instanceof Function )
				{
					dado = cfg.basevalue.call(this,v[i],total);
					//console.log( j, v[i] , dado );
				}
				else
				{
					dado = v[i][cfg.basevalue];
				}
				dados.push(dado);
			});

			dados.unshift( name.toString() );
			columns.push( dados );
		});
	}

	var g_cfg = {
			bindto:graph.get(0),
			color:{
				pattern:colorPattern,
			},
			size:{
				height:charMinHeight,
			},
			data: {
				columns: columns,
				type: 'donut',
				colors:dataColorPattern,
				onclick:function(d){
					return chartTooltipContents.call(this.internal,[d], null, null, this.internal.color, 1);
				}
			},
			axis:{
				x:{
					type: 'category',
					categories:data.xLabels,
				},
				y:{}
			},
			tooltip:{
				contents:function(d, defaultTitleFormat, defaultValueFormat, color){
					//console.log(arguments,this);
					if( Function.apply ) return chartTooltipContents.apply(this,arguments);
					return chartTooltipContents.call(this,d, defaultTitleFormat, defaultValueFormat, color);
				},
				format:{
					value:function(value,ratio,id,index){
						return val(value);//+" UNIT";
					}
				}
			}
		};

    if( cfg.showPositionInTooltip )
        g_cfg.showPositionInTooltip = cfg.showPositionInTooltip;

	if( cfg.colorPattern )
		g_cfg.color.pattern = cfg.colorPattern;
	if( cfg.dataColors )
		g_cfg.data.colors = cfg.dataColors;
	if( cfg.hideLegends )
		g_cfg.legend = { show: false };


	if( cfg.padding ){
		g_cfg.padding = cfg.padding;
	}

	if( cfg.size ){
		g_cfg.size = cfg.size;
	}

	if ( g_cfg.data.columns.length > 10 ){
		g_cfg.size.height += charPlusHeight * ( (g_cfg.data.columns.length / 10) * 0.8 );

		console.log( g_cfg.size.height );
	}

	if( isUpdate ){
        var last_g_cfg = graph.prop("g_cfg");
        if( last_g_cfg.data.type != g_cfg.data.type ){
            isUpdate = false;
            graph.html("");
        }
    }

	var chart;
	if( isUpdate )
	{
		var unload=[];
		chart = graph.prop("chart");
		var last_g_cfg = graph.prop("g_cfg"),
			conf;


		if( !data.empty )
		{
			if( g_cfg.data.columns instanceof Array ){
				for( var i in last_g_cfg.data.columns )
					unload.push( last_g_cfg.data.columns[i][0] );
				for( var i in g_cfg.data.columns )
					if( unload.indexOf( g_cfg.data.columns[i][0] ) != -1 ){
						unload.splice( unload.indexOf( g_cfg.data.columns[i][0] ) , 1 );
					}
			}

			conf = {unload:unload, columns:g_cfg.data.columns, rows:g_cfg.data.rows,categories:g_cfg.axis.x.categories, type:g_cfg.data.type };
		}
		else
		{
			conf = {unload:true};
		}

		chart.load( conf );
		if( last_g_cfg.size.height != g_cfg.size.height )
			setTimeout(function(){
				chart.resize({height:g_cfg.size.height});
			},660);

		if( !last_g_cfg.legendIsHide && g_cfg.data.columns.length >= 20 )
		{
			g_cfg.legendIsHide = true;
			setTimeout(function(){
				chart.legend.hide();
			},150);
		}
		else if( last_g_cfg.legendIsHide && g_cfg.data.columns.length < 20 )
		{
			delete g_cfg.legendIsHide;
			setTimeout(function(){
				chart.legend.show();
			},150);
		}

	}
	else
	{
		chart=c3.generate( g_cfg );
	}

	graph.attr({'data-chart':1}).prop({'chart':chart,'g_cfg':g_cfg});

}

function drawGraphGauge(data,cfg){

	var graph,
		title,
		isUpdate=false;

	if( (title=cfg.container.find("h4.chart-title")).length != 1 || (graph=cfg.container.find("div[data-chart]")).length != 1 )
	{
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>"+ otxt(cfg.title) +"</h4>").append( graph );
	}
	else
	{
		title.html( otxt(cfg.title) );
		isUpdate=true;
	}




	var columns = [],
		odados = [];


	if( !data.empty )
	{
		odados = data.values.slice();
		var total = getTotal( odados );

		$( data.yLabels ).each(function(i,name){
			var dados = [];

			$( odados ).each(function(j,v){
				var dado=null;
				if( !cfg.basevalue ) dado = v[i];
				else if( (cfg.basevalue) instanceof Function )
				{
					dado = cfg.basevalue.call(this,v[i],total);
					//console.log( j, v[i] , dado );
				}
				else
				{
					dado = v[i][cfg.basevalue];
				}
				dados.push(dado);
			});

			dados.unshift( name.toString() );
			columns.push( dados );
		});
	}

	var g_cfg = {
			bindto:graph.get(0),
			color:{
	//			pattern:colorPattern,
	//			pattern: ['#FF0000', /*'#F97600', */'#F6C600', '#60B044'], // color levels for the percentage values.
	//			threshold: {
	//           	unit: 'value', // percentage is default
	//          	max: 200, // 100 is default
	//				values: [40, 60, 100]
	//			}
			},
			size:{
				height:charMinHeight,
			},
			data: {
				columns: columns,
				type: 'gauge',
				colors:dataColorPattern,
				onclick:function(d){
					return chartTooltipContents.call(this.internal,[d], null, null, this.internal.color, 1);
				}
			},
	//		axis:{
	//			x:{
	//				type: 'category',
	//				categories:data.xLabels,
	//			},
	//			y:{}
	//		},
			tooltip:{
				contents:function(d, defaultTitleFormat, defaultValueFormat, color){
					//console.log(arguments,this);
					if( Function.apply ) return chartTooltipContents.apply(this,arguments);
					return chartTooltipContents.call(this,d, defaultTitleFormat, defaultValueFormat, color);
				},
				format:{
					value:function(value,ratio,id,index){
						return val(value);//+" UNIT";
					}
				}
			}
		};

    if( cfg.showPositionInTooltip )
        g_cfg.showPositionInTooltip = cfg.showPositionInTooltip;

	if( cfg.colorPattern )
		g_cfg.color.pattern = cfg.colorPattern;
	if( cfg.dataColors )
		g_cfg.data.colors = cfg.dataColors;
	if( cfg.hideLegends )
		g_cfg.legend = { show: false };


	if( cfg.padding ){
		g_cfg.padding = cfg.padding;
	}

	if( cfg.size ){
		g_cfg.size = cfg.size;
	}

	if ( g_cfg.data.columns.length > 10 ){
		g_cfg.size.height += charPlusHeight * ( (g_cfg.data.columns.length / 10) * 0.8 );

		console.log( g_cfg.size.height );
	}

	if( isUpdate ){
        var last_g_cfg = graph.prop("g_cfg");
        if( last_g_cfg.data.type != g_cfg.data.type ){
            isUpdate = false;
            graph.html("");
        }
    }

	var chart;
	if( isUpdate )
	{
		var unload=[];
		chart = graph.prop("chart");
		var last_g_cfg = graph.prop("g_cfg"),
			conf;


		if( !data.empty )
		{
			if( g_cfg.data.columns instanceof Array ){
				for( var i in last_g_cfg.data.columns )
					unload.push( last_g_cfg.data.columns[i][0] );
				for( var i in g_cfg.data.columns )
					if( unload.indexOf( g_cfg.data.columns[i][0] ) != -1 ){
						unload.splice( unload.indexOf( g_cfg.data.columns[i][0] ) , 1 );
					}
			}

			conf = {unload:unload, columns:g_cfg.data.columns, rows:g_cfg.data.rows,
				//categories:g_cfg.axis.x.categories,
				type:g_cfg.data.type };
		}
		else
		{
			conf = {unload:true};
		}

		chart.load( conf );
		if( last_g_cfg.size.height != g_cfg.size.height )
			setTimeout(function(){
				chart.resize({height:g_cfg.size.height});
			},660);

		if( !last_g_cfg.legendIsHide && g_cfg.data.columns.length >= 20 )
		{
			g_cfg.legendIsHide = true;
			setTimeout(function(){
				chart.legend.hide();
			},150);
		}
		else if( last_g_cfg.legendIsHide && g_cfg.data.columns.length < 20 )
		{
			delete g_cfg.legendIsHide;
			setTimeout(function(){
				chart.legend.show();
			},150);
		}

	}
	else
	{
		chart=c3.generate( g_cfg );
	}

	graph.attr({'data-chart':1}).prop({'chart':chart,'g_cfg':g_cfg});

}

function drawGraphProgressBar(data,cfg){

	var graph,
		title,
		isUpdate=false;

	if( (title=cfg.container.find("h4.chart-title")).length != 1 || (graph=cfg.container.find("div[data-chart]")).length != 1 )
	{
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>"+ otxt(cfg.title) +"</h4>").append( graph );
	}
	else
	{
		title.html( otxt(cfg.title) );
		isUpdate=true;
	}


	var columns = [],
		odados = [];


	if( !data.empty )
	{
		odados = data.values.slice();
		var total = getTotal( odados );

		$( data.yLabels ).each(function(i,name){
			var dados = [];

			$( odados ).each(function(j,v){
				var dado=null;
				if( !cfg.basevalue ) dado = v[i];
				else if( (cfg.basevalue) instanceof Function )
				{
					dado = cfg.basevalue.call(this,v[i],total);
					//console.log( j, v[i] , dado );
				}
				else
				{
					dado = v[i][cfg.basevalue];
				}
				dados.push(dado);
			});

			dados.unshift( name.toString() );
			columns.push( dados );
		});
	}

	graph.html('');
	var max = 100;
	var color = d3.scaleOrdinal(d3.schemeCategory10);
	columns.forEach(function(data,i){

		var v = val(data[1]);

		graph.addClass("progressbar-graph").append(
			$("<p>").addClass('text-right pl-4 pr-4').append(
				"<label>"+data[0]+"</label>",
				$("<div class='progress justify-content-end'>").css({height:"2px"})
					.append(
						$("<div class='progress-bar' role='progressbar'>").css({width:data[1]+"%",backgroundColor:color(i)})
					 )

			).tooltip({title:v+"%",placement:"top",})
			.hover(
				function(){$(this).addClass('hover')},
				function(){$(this).removeClass('hover')})
		)

	});


	//graph.attr({'data-chart':1}).prop({'chart':chart,'g_cfg':g_cfg});

}


function getTotal(values){
	//var tt = window.performance.now();
	var tmp = [];
	for(var i in values){
		if( !values.hasOwnProperty(i) ) continue;
		var v = values[i];
	//$(values).each(function(i,v){
		//console.log(i,v);
		var t = {};
		for(var ii in v){
			if(!v.hasOwnProperty(ii))continue;
			var vv = v[ii];
		//$(v).each(function(ii,vv){
			//console.log(ii,vv);
			for( var name in vv ){
				if( !vv.hasOwnProperty(name) ) continue;
				if( !t[name] ) t[name]=0;
				t[name]+=vv[name];
			}
		}
		//);
		tmp.push( t );
	}
	//console.log('TOTAL:',tmp,values );
	//);
	//var n=window.performance.now()
	//console.log( 'END:', n-tt, n,tt);
	return tmp;
}


function chartTooltipContents(d, defaultTitleFormat, defaultValueFormat, color, isclick ) {
	var $$ = this, config = $$.config,
		titleFormat = config.tooltip_format_title || defaultTitleFormat,
		nameFormat = config.tooltip_format_name || function (name) { return name; },
		valueFormat = config.tooltip_format_value || defaultValueFormat,
		text, i, title, value, name, bgcolor;

	var values = d,
		idselected;
	if( (config.data_type == 'donut' || config.data_type == 'gauge') && $$.api ){
		values = [];
		$$.api.data().forEach( function(v,idx){
			values.push( {id: v.id, value: v.values[0].value, index: idx, name: v.id} );
		});
		idselected = d[0].id;
	}

	var el = $(config.bindto);

    var g_cfg = (config.bindto.g_cfg) || {},
        showPosition = g_cfg && 'showPositionInTooltip' in g_cfg ? g_cfg.showPositionInTooltip : false;


//  var args = el.prop("data-args");
//         var unit = el.prop("data-unit");
//         var ids = el.prop("data-ids");

// 	if( !((args.multi) instanceof Array) )
		values.sort(function(a,b){ return (a.value > b.value ? -1 : 1); });

	for (i = 0; i < values.length; i++) {
		/// calc value;

		if (! (values[i] && (values[i].value || values[i].value === 0))) { continue; }

		if (! text) {
			title = titleFormat ? titleFormat(values[i].x) : values[i].x;
			text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='"+( showPosition? 3 : 2)+"'>" + title + "</th></tr>" : "");
		}

		var id = i;
//            for(var j in ids){
//                 if( ids[j] == d[i].id ){
//                     id=j;
//                     break;
//                 }
//             }
		name = nameFormat(values[i].name);

		/// calc value -- MARCELO
		/*if( (args.multi) instanceof Array && args.multi[id] ){
				value = d[i].value * args.multi[id] + args.base[id];
				if( (args.decimal) instanceof Array && args.decimal[id] )
					value = value.toFixed( args.decimal[id] );

                value = valTabela(value);

				if( (args.sufix) instanceof Array && args.sufix[id] )
					value += ""+args.sufix[id];
			}else*/
		{
				/// default calc
			value = values[i].value;
//                 if( (args.decimal) instanceof Array && args.decimal[id] & !isNaN(value*1) )
//                     value=value.toFixed( args.decimal[id] );

			value = valueFormat(value, values[i].ratio, values[i].id, values[i].index);
		}

		bgcolor = $$.levelColor ? $$.levelColor(values[i].value) : color(values[i].id);

		text += "<tr class='" + $$.CLASS.tooltipName + "-" + values[i].id + ( idselected == values[i].id ? " m-active" : "" ) + "'>";
        if( showPosition ){
            text += "<td class='pos'>"+(id+1)+"</td>";
        }
		text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
		text += "<td class='value'>" + value + "</td>";
		text += "</tr>";
	}
	text += "</table>";
	if( isclick !== 1 )
		return text

	frm.myAlert( 'Data', text, 'Close' );
};

function createElSVG(tag){
	return $(document.createElementNS('http://www.w3.org/2000/svg', tag));
}

function drawCirclePercent(perc, color, text, el, viewport){

	viewport = viewport != null && viewport.length == 2 ? viewport : [88,88,36];
	var pi = Math.PI;
	var r = viewport.length == 3 ? viewport[2] : viewport[0]-20;
	var dArr = 2*pi*r;

	//console.log( el.find("svg") , el.get(0).innerHTML );
	//console.log( perc );
	if( el && el.find("svg").length > 0 && el.find("svg").attr("data-svg-type")=="circle" ){

		var svg = el.find("svg");
		var bCircle = svg.find("circle[data-name='base']");
		var pCircle = svg.find("circle[data-name='percent']");
		var tTitle = svg.find("text[data-name='title']");
		var tSubTitle = svg.find("text[data-name='sub-title']");

	} else {
		var svg = createElSVG("svg");
		svg.attr("data-svg-type",'circle');

		if( el )
		{
			el.append(svg);
		}

		var bCircle = createElSVG("circle");
		bCircle.attr("data-name","base");

		var x = viewport[0] *2; // 0.264583333;
		var y = viewport[1] *2; //  0.264583333;




		svg.attr( {preserveAspectRatio:"xMidYMid meet", width:viewport[0],height:viewport[1], viewBox:"0 0 "+x+" "+y, version:'1.1', xmlns:'http://www.w3.org/2000/svg'} );
		//svg.css({border:"1px solid red" });

		bCircle.attr( {r:r, cx:x/2, cy:y/2, "stroke-dasharray":dArr, "stroke-dashoffset":0, fill:"transparent"} );
		bCircle.css({transition: "stroke-dashoffset 1s linear,stroke-width 300ms ease,fill 300ms ease",strokeDashoffset:0, stroke:/*"#EAEEF1"*/"#D8E3EA", strokeLinecap:"round", strokeWidth:"10px",transform:"rotate(93deg)", transformOrigin:"50% 50%"});

		var pCircle = $(bCircle.clone());
		pCircle.attr("data-name","percent");
		pCircle.css({stroke:color,strokeDashoffset:dArr,strokeWidth:"8px"});

		bCircle.css({fill:"#FFF"});
		var gEl = createElSVG("g");
		svg.append( gEl );

		gEl.append( [bCircle, pCircle] );

		gEl.attr({"data-id": text != null ? text[1] : "" });
		gEl.hover(function(e){
			var isEnter = e.type === "mouseenter" ? true : false;
			pCircle.css( {strokeWidth:(isEnter?"12px":"8px")} );
			//bCircle.css( {fill:(isEnter?"#FFF":"transparent")} );

// 				if( isEnter && lastChart != null ){
// 					var id = $(this).attr("data-id");
// 					if( id != "") {
// 						//console.log( id );
// 						id = id == "Frentes" ? "Frentes" : (id=="PDV"? "PDVs" : "KM");
// 						lastChart.focus(id);
// 					}
// 				}
// 				else if( lastChart != null ) {
// 					lastChart.revert();
// 				}


			$(this).find("text").each(function(){
		// 			if( this.id == "title" )
					$(this).css( {fill:e.type === "mouseenter" ? color:"#586478"} );
			});
		// 		bCircle.css("strokeWidth",e.type === "mouseenter"?"10px":"8px");
		});

		var tTitle = createElSVG("text");

		tTitle.attr({x:x/2, y:(y/2)-1, id:"title","data-name":"title"});
		tTitle.css({textAnchor: "middle",fill:"#586478",fontSize:"20px",transition: "fill 600ms ease"});
		var tSubTitle = tTitle.clone();
		tTitle.css({fontWeight:"bold",fontSize:"30px"});

		tSubTitle.attr({y:y/2+20, id:"subTitle","data-name":"sub-title"});

		gEl.append([tTitle, tSubTitle]);
		gEl.on("click",function(){
			//alert(text[1]);
		});

	}
	color = color ? color : "#10A2F9";
	/// CALC PERC
	//var c = pi*(r*2);
	var pert = perc<0?0:(perc>100?100:perc);
	var pct = ((100-perc)/100)*dArr;

	///inverter preenchimento
	//dArr *= -1; pct *= -1;

	setTimeout( function(){pCircle.css( {strokeDashoffset: pct} );},100);


	/// ADD TEXT
	if( text != null ) {
		tTitle.text(text[0]);
		tSubTitle.text(text[1]);
	}
	return svg;
}

function createExportTableBtns(){
    $("table.table").each(function(idx,el){
        el = $(el);

        var parent = el.parent().css({position:"relative"});

        if( parent.attr("data-btn-export-table") ) return;
        parent.attr("data-btn-export-table",1);

        var checkAndCreateDownloadBtn = function(parent){
            if( parent.children("span.download-table").length <= 0 ){
                var span = $("<span>")
                    .addClass("fas fa-cloud-download-alt download-table")
                    .attr({title:otxt("Download Table")})
                    .css({fontSize:"20px",position:"absolute",color:"#4CAF50", cursor:"pointer", display:"none",bottom:"4px",left:"10px"/*right:"0px"*/})
                    .on("click",function(){
                        var self = $(this).parent();
                        exportToExcelV2( self.children("table") );
                    })

                    parent.append( span );
            }
        }
        parent.mouseenter( function(){
                checkAndCreateDownloadBtn($(this));
                $(this).children("span").css({display:"inline-block"});
            })
            .mouseleave( function(){
                $(this).children("span").css({display:"none"});
            })
    });
}

function createExportGraphBtns(){
    $("svg").each(function(idx,el){
        el = $(el);
        var parent = el.parent();

        if( parent.attr("data-btn-export") || el.attr("data-svg-type") == 'circle' ) return;
        parent.attr("data-btn-export",1);

        var checkAndCreateDownloadBtn = function(parent){
            if( parent.children("span.download-graph").length <= 0 ){
                var span = $("<span>")
                    .addClass("fas fa-cloud-download-alt download-graph")
                    .attr({title:otxt("Download Chart")})
                    .css({fontSize:"20px",position:"absolute",color:"#2196F3", cursor:"pointer", display:"none",bottom:"4px",left:"20px"/*right:"-4px"*/})
                    .on("click",function(){
                        var self = this,
                            parent = $(this).parent(),
                            btns = $("<div>");

                        // if( parent.prop("g_cfg") )
                        //     btns.append(
                        //         oModal.genBTN({text:otxt("Table - Excel"),className:"btn btn-primary btn-theme",onclick:function(){
                        //             exportGraphToExcel( parent.get(0) );
                        //         }})
                        //     );
						//
                        // btns.append(
                        //     oModal.genBTN({text:otxt("Image"),className:"btn btn-primary btn-theme",onclick:function(){oModal.close();genImg( parent.children("svg") );}}),
                        //     oModal.genBTN({text:otxt("Cancel"),onclick:function(){oModal.close();}})
                        // );

						frm.myAlert( 'Export Chart', 'Choose Option',
							'Table Excel', function(){
								exportGraphToExcel( parent.get(0) );
							},
							'Image', function(){frm.myAlertClose();genImg( parent.children("svg") );},
							'Cancel'
						);

                        // showModal( {
                        //     header:otxt("Export Chart"),
                        //     body:otxt("Choose Option:"),
                        //     footer:btns,
                        // });

                        //genImg( parent.children("svg") );
                    })

                    parent.append( span );
            }
        }
        parent.mouseenter( function(){
                checkAndCreateDownloadBtn($(this));
                $(this).children("span").css({display:"inline-block"});
            })
            .mouseleave( function(){
                $(this).children("span").css({display:"none"});
            })
    });
}

function exportGraphToExcel(container){

    function generate_and_save(type){
        var graph_type = container.g_cfg ? 1 : 2, /// ; 1 == c3, 2 == radar;
            graph_cfg = graph_type == 1 ? container.g_cfg : container.__graph_radar_data__,
            graph_name = container.g_name ? container.g_name : "";

        console.log( graph_cfg );
        /// ; generate data to export
        var data;
        if( graph_type == 1 )
        {
            var columns;
            if( graph_cfg.data.rows ){
                var rows = graph_cfg.data.rows.slice();
                columns = [];
                $.each(rows,function(ridx,row){
                    $.each(row,function(cidx,col){
                        if( columns[cidx] == null )
                            columns[cidx]=[];
                        columns[cidx].push(col);
                    });
                });
            }
            else  {
                columns = graph_cfg.data.columns.slice();
            }
            var categories;
            if( graph_cfg.axis ) {
                if( graph_cfg.axis.x && graph_cfg.axis.x.type == 'category' )
                    categories = graph_cfg.axis.x.categories.slice();
                //if( graph_cfg.axis.y && graph_cfg.axis.y.type == 'category' )
                //    categories = graph_cfg.axis.y.categories;
            }

            var data = [];
            if( categories )
            {
                categories.unshift("");
                data = [ categories ];
            }

            if( graph_cfg.data.type == 'bar' && columns[0][0].indexOf('data') != -1 && categories )
            {
                data = [ ];
                $.each(columns,function(ridx,row){
                    $.each(row,function(cidx,col){
                        if( cidx == 0 ) return; /// ignora o 'data1' e a categoria ''
                        col = isFloat(col) ? (col*1).toFixed(5).toString().replace(/\./,',') : col;
                        data.push( [ categories[cidx], col ] );
                    });
                });
            }
            else
            {
                var args = container['data-args'];
                $.each(columns,function(ridx,row){
                    if( !args || !args.multi ) {
                        var row_formated=[];
                        $.each(row,function(cidx,col){
                            row_formated.push( isFloat(col) ? (col*1).toFixed(5).toString().replace(/\./,',') : col );
                        });
                        data.push(row_formated);
                    }else{
                        /// ; GRAFICO DA ANALISE
                        var row_formated=[];
                        $.each(row,function(cidx,col){
                            if(cidx==0){
                                row_formated.push(col);
                                return;
                            }
                            var value = col;
                            if( (args.multi) instanceof Array && args.multi[ridx] ){
                                value = value * args.multi[ridx] + args.base[ridx];
                                if( (args.decimal) instanceof Array && args.decimal[ridx] )
                                    value = value.toFixed( args.decimal[ridx] );
                                //if( (args.sufix) instanceof Array && args.sufix[ridx] )
                                //    value += ""+args.sufix[ridx];
                            }
                            value = value.toString().replace(/\./,',');
                            row_formated.push( value );
                        });
                        data.push(row_formated);
                    }
                });
            }
        }
        else
        {
            var data = [ ];
            $.each(graph_cfg.axes,function(idx,col){
                data.push( [ col.axis, col.value ] );
                //values.push( col.value );
            });
            //data = [ names, values ];

        }

        var out;
        if( type == 1 )
            out = csv(data);
        else
            out = formated(data);

        var saveName = "Grafico";
            if($(container).attr("data-title") ) saveName = $(container).attr("data-title");
        try {
            saveName=getSaveName(saveName);
        } catch(e) { }


        var url = window.URL||window.webkitURL;
        if( url instanceof Function && Uint8Array instanceof Function ) {
            //var out = tableTXT;
            /// fix acentos
            var blob;
            if( type == 1 ) {
                blob = new Blob([out], { encoding:"UTF-8", type:"text/csv;charset=UTF-8"} );
            } else {
                var data = new Uint8Array(out.length); for(var i = 0 ; i < data.length ;i++ ) data[i] = out.charCodeAt(i);
                blob = new Blob([data], { encoding:"UTF-8", type:"application/vnd.ms-excel;charset=UTF-8"} );
            }
//             var div = $("<div>")
//                 .append(
//                     $("<a>").html( otxt("Start") )
//                         .addClass( "btn btn-primary btn-theme" )
//                         .attr( "href", url.createObjectURL(blob) )
//                         .attr("download", saveName+ ( type==1?".csv" : ".xls" )  )
//                         .on("click",function(){ hideModal(); } ),
//                     $("<a>").html( otxt("Cancel") )
//                         .addClass( "btn btn-default" )
//                         .on("click",function(){ hideModal(); } )
//                  );
//
// 			frm.myAlert( 'Export Chart', '', '' )
//             showModal( {
//                 header:otxt("Export Chart"),
//                 className:"m-download",
// //                 body:"O arquivo está pronto para download. Clique em Iniciar:",//"O Arquivo foi criado clique no botão para Download-lo",
//                 footer:div,
//                 autoclose:false} );
//             return;
        }
        var form = $("<form></form>")
            .attr( {method:"post", action:"./export.php", target:"__blank"} )
            .css({position:"absolute",left:"-10000px",top:"-10000px"});
        var input = $("<input/>")
            .attr( {type:"hidden" , name:"table", value:out} );
        var inputName = $("<input/>")
            .attr( {type:"hidden" , name:"saveName", value:saveName} );

        form.append( [input,inputName] );
        $(document.body).append( form ); /// MAYBE NEED TO BE APPENDED

        form.trigger( "submit" );

        setTimeout( function(){ form.detach(); }, 500 );
    }

    function csv(data){

        var out = "";
        $.each(data,function(ridx,row){
            var line = ""
            $.each(row,function(cidx,col){
                line += (line == "" ? "" : ",")+"\""+col+"\"";
            })
            out += line+"\n";
        });
        return out;

    }
    function formated(data){
        var out = "<table border=0 cellpadding=0 cellspacing=0 bgcolor=\"#FFFFFF\">";

        $.each(data,function(ridx,row){
            out += "<tr>";
            $.each(row,function(cidx,col){
                out += "<td>"+col+"</td>";
            });
            out += "</tr>";
        });

        out += "</table>";
        return out;
    }

    // var div=$("<DIV>")
    //     .append(
    //         $("<button class='btn btn-primary btn-theme'>")
    //             .html( otxt("CSV") )
    //             .on("click",function(){
    //                 hideModal();
    //                 generate_and_save(1);
    //             }) ,
    //         $("<button class='btn btn-primary btn-theme'>")
    //             .html( otxt("XLS") )
    //             .on("click",function(){
    //                 hideModal();
    //                 generate_and_save(2);
    //             }),
    //         $("<button>").html( otxt("Cancel") )
    //             .addClass( "btn btn-default" )
    //             .on("click",function(){ hideModal(); } )
	//
    //     );

    // showModal({header:otxt("Export Chart"),body:otxt("Choose table format:"),footer:div});
}

function exportToExcelV2( mTable ){
	if( !(mTable instanceof $) ) {
		$(mTable);
		if( mTable.length < 1 ) return;
	}

	var args = arguments;

	/// get table as csv
	var export_csv = function(idx, mTable){
        var tableTXT = "";

        if( idx > 0 )
            tableTXT += "\n\n\n";

        var tr = mTable.find("thead");
        var line = "";
        tr.find("th:not(.t-col-acoes)").each(function(i){
            var td = $(this)
            line += (line == "" ? "": ",") + "\""+ td.text() + "\"";
        });

        tableTXT += line+"\n";

        var trs = mTable.find("tbody tr");
        trs.each(function(i){
            var tr = $(this);

            line = "";

            var tds = tr.find("td");
            tds.each( function(i){
                var td = $(this)
                var val = td.text();
				if( td.find("i").length )
				{
					var tmp = td.clone(),
						i = td.find("i");
					tmp.find("i").remove();
					val = tmp.text();
					//val += " ("+ ( typeof( i.attr('up') ) != "undefined" ? "↑" : typeof( i.attr("dn") ) != "undefined" ? "↓" :"-") +" "+i.text()+")";
				}
                else if( td.attr("data-type") == "boolean" && td.find(".m-checkbox").length == 1 ){
                    val = td.find(".m-checkbox").prop("checked");
                }
                line += (line == "" ? "" : ",") + "\"" +val + "\"";
            });
            tableTXT += line+"\n";
        });
        return tableTXT;
    };
	/// get table as xls
    var export_formated=function(idx, mTable){
        var tableTXT = "<table border=0 cellpadding=0 cellspacing=0 bgcolor=\"#FFFFFF\">";

        if( idx > 0 )
            tableTXT += "<tr></tr><tr></tr>";

        var tr = mTable.find("thead");
        var trColor = "#FFFFFF";
        tableTXT += "<tr bgcolor=\"#FFFFFF\" height=\""+tr.height()+">";
        tableTXT += "<font color=\"#000000\">"
        tr.find("th:not(.t-col-acoes)").each(function(i){
                var td = $(this)
                var val = td.text();
                //console.log( escape(val) );
                tableTXT += "<td align=\"center\" bgcolor=\""+ trColor +"\" width=\""+td.width()+"\" height=\""+td.height()+"\"";
                if( td.attr("colspan") ) tableTXT += " colspan=\""+td.attr("colspan")+"\"";
                if( td.attr("rowspan") ) tableTXT += " rowspan=\""+td.attr("rowspan")+"\"";
                tableTXT += ">";
                tableTXT += "<font color=\"#000000\">" + val + "</font>";
                tableTXT += "</td>";
            });
        tableTXT += "</font>";
        tableTXT += "</tr>\n";

        var trs = mTable.find("tbody tr");
        trs.each(function(i){
            var tr = $(this);
            var trColor = rgb2hex(tr.css("backgroundColor"));
            tableTXT += "<tr bgcolor=\""+trColor+"\" height=\""+tr.height()+">";
            tableTXT += "<font color=\""+ rgb2hex( tr.css("color") )+"\">"
            var tds = tr.find("td");
            tds.each( function(i){
                var td = $(this)
                var val = td.text();
				if( td.find("i").length )
				{
					var tmp = td.clone(),
						i = td.find("i");
					tmp.find("i").remove();
					val = tmp.text();
					//var type = typeof( i.attr('up') ) != "undefined" ? "UP" : typeof( i.attr("dn") ) != "undefined" ? "DN" :"MID";
					//val += " ("+ type +" "+i.text()+")";
				}
                else if( td.attr("data-type") == "boolean" && td.find(".m-checkbox").length == 1 ){
                    val = td.find(".m-checkbox").prop("checked");
                }
                var tdColor = rgb2hex( td.css("backgroundColor") );
                tdColor = tdColor == '' || tdColor == null ? trColor : tdColor;
                tableTXT += "<td align=\"center\" bgcolor=\""+ tdColor +"\" width=\""+td.width()+"\" height=\""+td.height()+"\"";
                if( td.attr("colspan") ) tableTXT += " colspan=\""+td.attr("colspan")+"\"";
                if( td.attr("rowspan") ) tableTXT += " rowspan=\""+td.attr("rowspan")+"\"";
                tableTXT += ">";
                tableTXT += "<font color=\""+ rgb2hex( td.css("color") )+"\">" + val + "</font>";
                tableTXT += "</td>";
            });
            tableTXT += "</font>";
            tableTXT += "</tr>\n";
        });
        tableTXT += "</table>";
        return tableTXT;
    };

    var generate_and_save = function( type ){

        var out = "";
        $(args).each( function(idx,mTable){
            if( !(mTable instanceof $) ) mTable= $(mTable);
            out += type==1 ? export_csv(idx,mTable) : export_formated( idx,mTable );



        } );
        var t = type==1?"CSV":"EXCEL";
        var saveName = t+"_"+new Date().getTime(); //getSaveName()
        try{
            saveName = getSaveName(t);
        }catch(e){}

        var url = window.URL||window.webkitURL;
        if( url instanceof Function && Uint8Array instanceof Function ) {
            //var out = tableTXT;
            /// fix acentos
            var blob;
            if( type == 1 ) {
                blob = new Blob([out], { encoding:"UTF-8", type:"text/csv;charset=UTF-8"} );
            } else {
                var data = new Uint8Array(out.length); for(var i = 0 ; i < data.length ;i++ ) data[i] = out.charCodeAt(i);
                blob = new Blob([data], { encoding:"UTF-8", type:"application/vnd.ms-excel;charset=UTF-8"} );
            }
            // var div = $("<div>")
            //     .append(
            //         $("<a>").html( otxt("Download") )
            //             .addClass( "btn btn-primary btn-theme" )
            //             .attr( "href", url.createObjectURL(blob) )
            //             .attr("download", saveName+ ( type==1?".csv" : ".xls" )  )
            //             .on("click",function(){ hideModal(); } ),
            //         $("<a>").html( otxt("Cancel") )
            //             .addClass( "btn btn-default" )
            //             .on("click",function(){ hideModal(); } )
            //      );
			//
            // showModal( {
            //     header:otxt("Export current View"),
            //     className:"m-download",
            //     body:otxt("File is ready for download. Click on 'Start':"),
            //     footer:div,
            //     autoclose:false} );
            // return;
        }

        var form = $("<form></form>")
            .attr( {method:"post", action:"./export.php", target:"__blank"} )
            .css({position:"absolute",left:"-10000px",top:"-10000px"});
        var input = $("<input/>")
            .attr( {type:"hidden" , name:"table", value:out} );
        var inputName = $("<input/>")
            .attr( {type:"hidden" , name:"saveName", value:saveName} );

        form.append( [input,inputName] );
        $(document.body).append( form ); /// MAYBE NEED TO BE APPENDED

        form.trigger( "submit" );

        setTimeout( function(){ form.detach(); }, 500 );
    }




    // var div=$("<DIV>")
    //     .append(
    //         $("<button>")
    //             .addClass( "btn btn-primary btn-theme" )
    //             .html( otxt("CSV") )
    //             .on("click",function(){
    //                 hideModal();
    //                 generate_and_save(1);
    //             }) ,
    //         $("<button>")
    //             .addClass( "btn btn-primary btn-theme" )
    //             .html( otxt("XLS") )
    //             .on("click",function(){
    //                 hideModal();
    //                 generate_and_save(2);
    //             }),
    //         $("<button>").html( otxt("Cancel") )
    //             .addClass( "btn btn-default" )
    //             .on("click",function(){ hideModal(); } )
	//
    //     );

    // showModal({header:otxt("Export current view"), /*className:"m-download",*/ body:otxt("Choose format:"),footer:div});

    //generate_and_save();
}

var hexDigits = new Array        ("0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f");
//Function to convert hex format to a rgb color
function rgb2hex(rgb) {
	if( !rgb ) return "";
     if (  rgb.search("rgb") == -1 ) {
          return rgb;
     } else {
          rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
		  if( !rgb ) return "";
		  if( rgb.length == 5 && rgb[4] == 0 && rgb[3] == 0 && rgb[2] == 0 && rgb[1] == 0 ){
			  return "";
		  }
          function hex(x) {
               return ("0" + parseInt(x).toString(16)).slice(-2);
          }
          return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
     }
}

function genImg(svg){

	function outerHTML(el) {
		var outer = document.createElement('div');
		//outer.appendChild(el.cloneNode(true));
		outer.appendChild( $(el).clone( true ).get(0) );
		return outer.innerHTML;
	}
	function setAttributes(el) {
		//el.attr("version", "1.1");
		el.attr("xmlns", "http://www.w3.org/2000/svg");
		//el.attr("xmlns:xlink", "http://www.w3.org/1999/xlink");
	}
	function styles(dom) {
		var used = "";
		var sheets = document.styleSheets;
		for (var i = 0; i < sheets.length; i++) {
			var rules;
			try{
				rules = sheets[i].cssRules;
			}catch(e){ continue; };

            if( rules != null )
			for (var j = 0; j < rules.length; j++) {
				var rule = rules[j];
				if (typeof(rule.style) != "undefined") {
					var elems = dom.querySelectorAll(rule.selectorText);
					if (elems.length > 0 ) {
						used += rule.selectorText + " { " + rule.style.cssText + " }\n";
					}
				}
			}
			console.log( sheets[i] , used );
		}
		//used=SVG_STYLE;
		var s = document.createElement('style');
		//s.setAttribute('type', 'text/css');
		s.innerHTML = "/*<![CDATA[*/\n" + used + " text{font-size:11px;} path,line { fill: none; stroke: #000; } \n/*]]>*/";

		var defs = document.createElement('defs');
		defs.appendChild(s);
		dom.insertBefore(s,dom.firstChild);

		//document.body.append( dom );
		//if( dom.firstChild.tagName.toLowerCase() == "defs" )
		//	dom.firstChild.insertBefore(s,dom.firstChild.firstChild);
		//else
		//	dom.insertBefore(defs, dom.firstChild);
	}
	function svgImage(xml) {



		var image = new Image();
		image.src = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(xml)));
		image.onload = function() {
			var canvas = document.createElement('canvas');
			$(canvas).css({backgroundColor:"#FFF"});
			canvas.width = image.width;
			canvas.height = image.height;
			var context = canvas.getContext('2d');
			/// BG COLOR {
			context.fillStyle = "#FFF";
			context.fillRect(0,0,image.width,image.height);
			/// }
			context.drawImage(image, 0, 0);

			var a = document.createElement('a');
			var name = "Image";
                if(svg && $(svg).parent().attr("data-title") ) name = $(svg).parent().attr("data-title");
			try{
				name=getSaveName(name);
			} catch(e){ console.log(e); }
			a.download = name+".png";
			a.href = canvas.toDataURL('image/png');
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}
	}

    if( svg )
        svg = svg.get(0);
    else
        svg = $('svg').get(0);
	if( $(svg).length == 0 ) return;
	setAttributes( $(svg) );
	if( $(svg).attr("hasSetStyle") != 1 ){
		$(svg).attr( {"hasSetStyle":1} );
		styles(svg);
	}
	var outer = outerHTML(svg);

	console.log(svg);
	svgImage(outer);
}

var treeMapId = 1;
function treemapNode( name, count, parent ) {
	var o = {
		id: treeMapId++,
		name: name,
		value: count || 0,
		parent: parent || null,
	}
	if( parent ) {
		if( !parent.children ) parent.children = [];
		parent.children.push(o);
	}
	// while( parent ) {
	// 	parent.value += count;
	// 	parent = parent.parent;
	// }
	return o;
}

function drawTreemap(data, cfg) {
	console.log( 'DATA', data )
	var graph,
		title,
		isUpdate = false;

	if ((title = cfg.container.find("h4.chart-title")).length != 1 || (graph = cfg.container.find("div[data-chart]")).length != 1) {
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>" + otxt(cfg.title) + "</h4>").append(graph);
	}
	else {
		title.html(otxt(cfg.title));
		isUpdate = true;
	}

	graph.addClass('treebody')
	// set the dimensions and margins of the graph
	var margin = { top: -20, right: 5, bottom: 20, left: 5 },
		width = charMinHeight - margin.left - margin.right,
		height = charMinHeight - margin.top - margin.bottom;

	// append the svg object to the body of the page
	var svg = d3.select(graph[0])
		.append("svg")
		.attr("width", graph.width())
		.attr("height", height + margin.top + margin.bottom)
		.append("g")
		.attr("transform",
			"translate(" + (margin.left+(graph.width()-charMinHeight)/2) + "," + margin.top + ")")

	// read json data

	// Give the data to this cluster layout:
	var root = d3.hierarchy(data).sum(function (d) { return d.value }) // Here the size of each leave is given in the 'value' field in input data

	// Then d3.treemap computes the position of each element of the hierarchy
	d3.treemap()
		.size([width, height])
		.paddingTop(28)
		.paddingRight(7)
		.paddingInner(3)      // Padding between each rectangle
		//.paddingOuter(6)
		//.padding(20)
		(root)

	// prepare a color scale
	var color = d3.scaleOrdinal()
	// .domain(["boss1", "boss2", "boss3"])
	.domain(["boss1", "boss2", "boss3"])
	.range(["#402D54", "#D18975", "#8FD175"])

	var domain = data.children.map( v => v.name)
	var palete = frm.paletteWheel(domain.length, 0.7);
	console.log( 'PALETE', palete )

	var color = d3.scaleOrdinal()
	// .domain(["boss1", "boss2", "boss3"])
	.domain(domain)
	.range(palete)




	console.log( 'COLOR', color )

	// And a opacity scale
	var opacity = function(x) { return 1 }
	// var opacity = d3.scaleLinear()
	// // .domain([10, 30])
	// .domain([10, 30])
	// .range([.5, 1])

	// use this information to add rectangles:
	svg
		.selectAll("rect")
		.data(root.leaves())
		.enter()
		.append("rect")
		.attr('x', function (d) { return d.x0; })
		.attr('y', function (d) { return d.y0; })
		.attr('width', function (d) { return d.x1 - d.x0; })
		.attr('height', function (d) { return d.y1 - d.y0; })
		.style("stroke", "black")
		.style("fill", function (d) { return color(d.parent.data.name) })
		.style("opacity", function (d) { return opacity(d.data.value) })
		// .attr('title', function (d) { return d.data.name + ' - ' + d.data.value } )


	// and to add the text labels
	// svg
	// 	.selectAll("text")
	// 	.data(root.leaves())
	// 	.enter()
	// 	.append("text")
	// 	.attr("x", function (d) { return d.x0 + 5 })    // +10 to adjust position (more right)
	// 	.attr("y", function (d) { return d.y0 + 10 })    // +20 to adjust position (lower)
	// 	.attr('width', function (d) { return d.x1 - d.x0; })
	// 	.attr('height', function (d) { return d.y1 - d.y0; })
	// 	.text(function (d) { return d.data.name + ' - ' + d.data.value })
	// 	.attr("font-size", "19px")
	// 	.attr("fill", "white")


		svg
		.selectAll("text")
		.data(root.leaves())
		.enter()
		.append('foreignObject')
		.attr("x", function (d) { return d.x0 })    // +10 to adjust position (more right)
		.attr("y", function (d) { return d.y0 })    // +20 to adjust position (lower)
		.attr('width', function (d) { return d.x1 - d.x0; })
		.attr('height', function (d) { return d.y1 - d.y0; })
		.attr("class", "foreignObject")
		.append("xhtml:body")
		.attr("class", "labelbody")
		.append("div")
		.attr("class", "label")
		.text(function (d) { return d.data.name + ' (' + d.data.value + ')' })
		.attr('title', function (d) { return d.data.name + ' (' + d.data.value + ')' } )
		.style('width', function (d) { return (d.x1 - d.x0)+'px'; } )
		.style('height', function (d) { return (d.y1 - d.y0)+'px'; })


	// // and to add the text labels
	// svg
	// 	.selectAll("vals")
	// 	.data(root.leaves())
	// 	.enter()
	// 	.append("text")
	// 	.attr("x", function (d) { return d.x0 + 5 })    // +10 to adjust position (more right)
	// 	.attr("y", function (d) { return d.y0 + 35 })    // +20 to adjust position (lower)
	// 	.text(function (d) { return d.data.value })
	// 	.attr("font-size", "11px")
	// 	.attr("fill", "white")

	// Add title for the 3 groups
	svg
		.selectAll("titles")
		.data(root.descendants().filter(function (d) { return d.depth == 1 }))
		.enter()
		.append("text")
		.attr("x", function (d) { return d.x0 })
		.attr("y", function (d) { return d.y0 + 20 })
		.text(function (d) { return d.data.name })
		.attr("font-size", "19px")
		.attr("fill", function (d) { return color(d.data.name) })

	// // Add title for the 3 groups
	// svg
	// 	.append("text")
	// 	.attr("x", 0)
	// 	.attr("y", 14)    // +20 to adjust position (lower)
	// 	.text("Three group leaders and 14 employees")
	// 	.attr("font-size", "19px")
	// 	.attr("fill", "grey")
	// $(document).tooltip({show: null});
}


function drawHeatmap( d, cfg ) {
	var graph,
	title,
	isUpdate=false;

	if( (title=cfg.container.find("h4.chart-title")).length != 1 || (graph=cfg.container.find("div[data-chart]")).length != 1 )
	{
		graph = $("<div>");
		cfg.container.html("<h4 class='chart-title'>"+ otxt(cfg.title) +"</h4>").append( graph );
	}
	else
	{
		title.html( otxt(cfg.title) );
		isUpdate=true;
	}

	var colorscaleValue = [
		[0, '#3D9970'],
		[1, '#001f3f']
	  ];
	  
	  var data = [{
		x: d.xValues,
		y: d.yValues,
		z: d.zValues,
		type: 'heatmap',
		colorscale: colorscaleValue,
		showscale: false
	  }];
	  
	  var layout = {
		title: 'Annotated Heatmap',
		annotations: [],
		xaxis: {
		  ticks: '',
		  side: 'top'
		},
		yaxis: {
		  ticks: '',
		  ticksuffix: ' ',
		  width: 700,
		  height: 700,
		  autosize: false
		}
	  };
	//   return;
	  
	  for ( var i = 0; i < d.yValues.length; i++ ) {
		for ( var j = 0; j < d.xValues.length; j++ ) {
		  var currentValue = d.zValues[i][j];
		  if (currentValue != 0.0) {
			var textColor = 'white';
		  }else{
			var textColor = 'black';
		  }
		  var result = {
			xref: 'x1',
			yref: 'y1',
			x: d.xValues[j],
			y: d.yValues[i],
			text: d.zValues[i][j],
			font: {
			  family: 'Arial',
			  size: 12,
			  color: 'rgb(50, 171, 96)'
			},
			showarrow: false,
			font: {
			  color: textColor
			}
		  };
		  layout.annotations.push(result);
		}
	  }
	  
	//   Plotly.newPlot(graph, data, layout);


}



export default {
	drawGraphLine:drawGraphLine,
	drawGraphBar: drawGraphBar,
	drawGraphDonut: drawGraphDonut,
	drawGraphGauge: drawGraphGauge,
	drawGraphProgressBar: drawGraphProgressBar,
	drawTreemap: drawTreemap,
	treemapNode: treemapNode,
	drawHeatmap: drawHeatmap,
};
